import View from 'mixins/view';
import moment from 'moment/moment';
import { matchCalendarModel } from 'models/MatchCalendarModel';
import Hammer from 'hammerjs';
import tippy from 'tippy.js';

const elements = {
  container: '.c-calendar-main-dayly_match_main',
  score: '.c-calendar__score',
  leftArrow: '.c-match-arrow__previous',
  rightArrow: '.c-match-arrow__next',
  live: '.c-match__live',
  mobile: '.c-calendar__mobile-manipulation',
};

export default class extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
    model.addEventListener('updateLive', this.updateMatchScore.bind(this));
  }
  setScore() {
    const home = this.model.get('homeScore');
    const away = this.model.get('awayScore');

    if (!isNaN(parseInt(home)) && !isNaN(parseInt(away))) {
      this.rootEl.find(elements.score)
        .html(`
          <h5 class="score-huge rmpl-flex-container rmpl-flex-aligned">${home}<span>:</span>${away}</h5>
        `);
    }
  }
  updateMatchScore() {
    const live = this.rootEl.find(elements.live);
    if (this.model.get('isLive')) {
      live.removeClass('fn-hidden')
        .html(this.model.get('liveMinute'));
    } else {
      live.addClass('fn-hidden');
    }
    this.setScore();
  }
  bulkArrows() {
    const prevDay = matchCalendarModel.getCurrentDay().get('prevDay');
    const nextDay = matchCalendarModel.getCurrentDay().get('nextDay');

    if (prevDay) {
      this.rootEl.find(elements.leftArrow)
        .removeClass('fn-hidden')
        .on('click', () => {
          matchCalendarModel.setCurrentDay(prevDay);
          matchCalendarModel.fireEvent('jumpToDay', {
            day: prevDay,
            direction: 'back',
          });
        });
    } else {
      this.rootEl.find(elements.leftArrow)
        .addClass('fn-hidden');
    }
    if (nextDay) {
      this.rootEl.find(elements.rightArrow)
        .removeClass('fn-hidden')
        .on('click', () => {
          matchCalendarModel.setCurrentDay(nextDay);
          matchCalendarModel.fireEvent('jumpToDay', {
            day: nextDay,
            direction: 'forward',
          });
        });
    } else {
      this.rootEl.find(elements.rightArrow)
        .addClass('fn-hidden');
    }
  }
  initTooltips() {
    const tippies = tippy('.c-match-popover-trigger',
    {
        content: 'Termin nie jest jeszcze oficjalnie potwierdzony',
        arrow: true,
        arrowType: 'round',
        placement: 'bottom',
        sticky: true,
        theme: 'dark match-popover'
    })
  }
  initHammer() {
    const container = this.rootEl.find(elements.mobile).get(0);
    const mc = new Hammer(container);
    const prevDay = matchCalendarModel.getCurrentDay().get('prevDay');
    const nextDay = matchCalendarModel.getCurrentDay().get('nextDay');

    mc.on('swiperight', (ev) => {
      if (!prevDay) {
        return;
      }
      matchCalendarModel.setCurrentDay(prevDay);
      matchCalendarModel.fireEvent('jumpToDay', {
        day: prevDay,
        direction: 'back',
      });
    });

    mc.on('swipeleft', (ev) => {
      if (!nextDay) {
        return;
      }
      matchCalendarModel.setCurrentDay(nextDay);
      matchCalendarModel.fireEvent('jumpToDay', {
        day: nextDay,
        direction: 'forward',
      });
    });
  }
  render() {
    const model = this.model;
    this.rootEl.html(`
      <div class="c-calendar__mobile-manipulation"></div>
      <h6 class="text-color_appgrey box-vertical_align_middle">
          <strong class="cursor-pointer box-inline c-match-popover-trigger">${moment(matchCalendarModel.get('currentDay')).format('D MMMM YYYY')}, ${model.get('startHour')} *</strong>
          <img src="${model.get('icon')}" class="c-calendar-ballicon shift-margin_2-horizontal box-inline">
          <div class="calendar-competition-type">
              <span class="box-inline">${model.get('competition')}</span>
          </div>
          <span class="c-match__live fn-hidden"></span>
      </h6>
      <div class="mw-wrapper rmpl-flex-container box-full_width rmpl-flex-nowrap">
        <div class="c-match-arrow__previous rmpl-flex-item-auto fn-hidden">
          <i class="icon-size_5-arrow_left-color_lightgrey"></i>
        </div>
        <div class="match-container rmpl-flex-item">
          <div class="rmpl-flex-nowrap rmpl-flex-container rmpl-flex-aligned">
            <div class="mc-left rmpl-flex-item">
              <div class="mc-item-container rmpl-flex-container rmpl-flex-aligned rmpl-flex-end rmpl-flex-nowrap">
                <div class="mc-item-cell mc-item-mobile-disabled">
                  <h4 class="cf">${model.get('homeTeam')}</h4>
                </div>
                <div class="mc-item-cell">
                  <img src="${model.get('homeLogo')}" class="element-image" alt="Club Flag">
                </div>
                <div class="mc-item-cell mc-item-mobile-enabled">
                  <h4 class="cf">${model.get('homeTeam')}</h4>
                </div>
              </div>
            </div>
            <div class="mc-score c-calendar__score rmpl-flex-item-auto">
              <h5 class="score-small rmpl-flex-container rmpl-flex-aligned">vs</h5>
            </div>
            <div class="mc-right rmpl-flex-item">
              <div class="mc-item-container rmpl-flex-container rmpl-flex-aligned rmpl-flex-start rmpl-flex-nowrap">
                <div class="mc-item-cell">
                  <img src="${model.get('awayLogo')}" class="element-image" alt="">
                </div>
                <div class="mc-item-cell mc-item-mobile-disabled">
                  <h4 class="cf">${model.get('awayTeam')}</h4>
                </div>
                <div class="mc-item-cell mc-item-mobile-enabled">
                  <h4 class="cf">${model.get('awayTeam')}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-match-arrow__next rmpl-flex-item-auto fn-hidden">
          <i class="icon-size_5-arrow_right-color_lightgrey"></i>
        </div>
      </div>
    `);
    this.initTooltips();
    this.initHammer();
    this.setScore();
    this.bulkArrows();
    this.updateMatchScore();
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/event/main-day-view.js